import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    skillMatrixs:[]
}


  export const fetchSkillMatrix = createAsyncThunk('rolewisematrix/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/rolewisematrix`)
    return response.data
  })

let userSlice = createSlice({
  name:'skillmatrix',//Root Reducer Name
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchSkillMatrix.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchSkillMatrix.fulfilled,(state,action)=>{
          state.isLoading = false
          state.skillMatrixs = action.payload
      })
      .addCase(fetchSkillMatrix.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;